import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants'
import {
	RetentionAnalyticsService,
	TTFBDistributionQuery,
	TTFBDistributionResponse,
} from '../services'

export const useQueryGetTTFBDistribution = (
	query?: TTFBDistributionQuery,
	enabled = true,
) => {
	return useQuery<TTFBDistributionResponse>({
		queryKey: QUERY_KEYS.RETENTION_ANALYTICS.TTFB(query),
		queryFn: () => RetentionAnalyticsService.getTTFBDistribution(query),
		enabled,
	})
}
